<template>
	<div>
		<div class="fz-12">起：{{ row.apply_start_time }}</div>
		<div class="fz-12">止：{{ row.apply_end_time }}</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
	components: {},
	data() {
		return {};
	},
};
</script>
